import _purposeTranslation from './purposeTranslations';
import { PurposeTranslations } from '../../types';

export const purposeTranslation = _purposeTranslation as PurposeTranslations;
